import { render, staticRenderFns } from "./TransactionsHistory.vue?vue&type=template&id=bf746fa2&scoped=true&"
import script from "./TransactionsHistory.vue?vue&type=script&lang=js&"
export * from "./TransactionsHistory.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsHistory.vue?vue&type=style&index=0&id=bf746fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf746fa2",
  null
  
)

export default component.exports